import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../../components/common/Header";
import useDataTable from "../../../components/common/DataTable";
import {
  fetchDepartments,
  deleteDepartment,
  fetchAllDepartments,
} from "../../../api/redux/action/DepartmentActions";
import { exportRequest } from "../../../api/network/axios/exportRequest";
import DepartmentActionView from "../../../components/common/ActionMenu";
import useNotification from "../../../components/common/ResultNotifier";
import { hasPermission } from "../../layout/Constants";
import { useHistory } from "react-router-dom";
function Departments() {
  const dispatch = useDispatch();
  const [exportAllLoading, setExportAllLoading] = useState(false);
  const [searchText, setSearchText] = useState();
  const [flattenedAllData, setFlattenedAllData] = useState([]);
  const [dataTable, setDataTable] = useState();
  const [sortedInfo, setSortedInfo] = useState({
    columnKey: null,
    order: null,
  });

  let history = useHistory();

  const {
    departments,
    allDepartments,
    error,
    requestStatus,
    loading,
    user,
    language,
    englishLang,
    selectedTenant,
  } = useSelector((store) => ({
    departments: store.departmentReducer.departments,
    allDepartments: store.departmentReducer.allDepartments,
    error: store.departmentReducer.error,
    requestStatus: store.departmentReducer.requestStatus,
    loading: store.departmentReducer.loading,
    user: store.authReducer.user,
    language: store.langReducer.language,
    englishLang: store.langReducer.englishLang,
    selectedTenant: store.authReducer.selectedTenant,
  }));

  const columns = [
    {
      title: language?.NAME?.value ?? englishLang?.NAME?.value,
      dataIndex: "name",
      sorter: true,
      sortField: "name",
      sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
      render: (name) => (
        <a
          onClick={() => {
            const viewOption = "disabled";

            history.push({
              pathname: "/update-department",
              state: { selectedRow, viewOption },
            });
          }}
        >
          {name}
        </a>
      ),
    },
  ];

  const [allowPermission, setAllowPermission] = useState({
    edit: hasPermission(selectedTenant, "UPDATE_DEPARTMENTS"),
    delete: hasPermission(selectedTenant, "DELETE_DEPARTMENTS"),
  });

  const [ResultNotifier, isLoading] = useNotification(error, requestStatus);

  const handleSingleDelete = (selected) => {
    dispatch(deleteDepartment(selected.departmentId));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText({
      ...searchText,
      [dataIndex]: selectedKeys[0],
    });
  };

  const {
    DataTable,
    selectedRow,
    hasSelected,
    currentPage,
    pageSize,
    sortField,
    sortOrder,
    searchFormHelperHandler,
  } = useDataTable({
    columns,
    source: "department",
    dataSource: departments,
    updateEntityPath: "update-department",
    customActionView:
      allowPermission.edit || allowPermission.delete
        ? DepartmentActionView
        : "",
    searchText,
    loading: loading,
    handleSingleDelete,
    allowPermission,
    setSortedInfo,
    title: language?.DEPARTMENTS?.value ?? englishLang?.DEPARTMENTS?.value,
  });

  useEffect(() => {
    dispatch(
      fetchDepartments({
        page: searchFormHelperHandler(),
        size: pageSize,
        searchText: searchText,
        sort: sortedInfo.columnKey
          ? sortedInfo.columnKey +
            "," +
            (sortedInfo.order == "ascend" ? "ASC" : "DESC")
          : null,
      })
    );
  }, [currentPage, isLoading, searchText, sortedInfo]);

  useEffect(() => {
    setDataTable(DataTable);
  }, [loading, selectedRow, language]);

  const handleExportAllButtonClick = () => {
    setExportAllLoading(true);
    const exportName = "export-departments";
    let options = {
      url: "/api/web/departments/export",
      method: "GET",
      responseType: "blob", // important\
      withCredentials: true,
      headers: {
        Accept: "application/vnd.handson.rfid.v5+json",
      },
    };

    options = {
      ...options,
      params: {
        searchText: searchText,
      },
    };
    exportRequest(options, setExportAllLoading, exportName);
  };

  let flattenedData = [];

  if (Object.keys(departments).length !== 0) {
    flattenedData = Object.values(departments.content);
  }

  useEffect(() => {
    if (allDepartments && Object.keys(allDepartments).length !== 0) {
      setFlattenedAllData(Object.values(allDepartments.content));
    }
  }, [allDepartments]);

  const headers = [
    { label: language?.NAME?.value ?? englishLang?.NAME?.value, key: "name" },
  ];

  const addNewPath = hasPermission(selectedTenant, "CREATE_DEPARTMENTS")
    ? "add-department"
    : "";

  return (
    <>
      <div style={{ padding: 24, background: "#fff", minHeight: 20 }}>
        <Header
          addNewPath={addNewPath}
          hasSelected={hasSelected}
          exportTableTitle={
            language?.DEPARTMENTS?.value ?? englishLang?.DEPARTMENTS?.value
          }
          addNewText={
            language?.ADD_DEPARTMENT?.value ??
            englishLang?.ADD_DEPARTMENT?.value
          }
          title={
            language?.DEPARTMENTS?.value ?? englishLang?.DEPARTMENTS?.value
          }
          csvData={flattenedData}
          csvAllData={flattenedAllData}
          csvHeaders={headers}
          exportAllButtonClick={handleExportAllButtonClick}
          exportAllLoading={exportAllLoading}
          loading={loading}
          exportButton={true}
          exportAllButton={true}
          handleSearch={setSearchText}
          tooltipText={
            language?.TOOLTIP_SEARCH_NAME?.value ??
            englishLang?.TOOLTIP_SEARCH_NAME?.value
          }
        />
        {dataTable}
        <ResultNotifier />
      </div>
    </>
  );
}

export default Departments;
